import { Button } from 'flowbite-react';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import AssetApi from '../../../Api/AssetApi';
import { useAppSelector } from '../../../Reducers/store';
import ViewReportModal from '../../Common/ViewReportModal';
import UserApi from '../../../Api/UserApi';
import { MoonLoader, PropagateLoader } from 'react-spinners';

export default function ViewDailyRoute() {
  const { userModel } = useAppSelector((state) => state.user);
  const [show, setshow] = useState<boolean>(false);
  const [pdfBlob, setpdfBlob] = useState<Blob | null>(null);
  const [pdfURL, setPDFURL] = useState<string>('');
  const [fileName, setfileName] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const getAssets = useCallback(() => {
    try {
      setIsLoading(true);
      return AssetApi.getAssetList()
        .then((res) => {
          //   setassetListData(
          //     res.data.filter(
          //       (x) =>
          //         x.statusId === AssetStatusEnum.GreenTagged ||
          //         x.statusId == AssetStatusEnum.YellowTagged
          //     )
          //   );
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    } catch (error) {
      console.error(error);
      toast.error('Error');
      setIsLoading(false);
    }
  }, []);

  const handleTodaysRoute = async () => {
    if (userModel) {
      setIsLoading(true);
      setButtonDisabled(true);
      await UserApi.getTodaysRoute(userModel?.id)
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(pdfBlob);
          setpdfBlob(pdfBlob);
          setPDFURL(url);
          setfileName('TodaysRoute');
          setshow(true);
          setIsLoading(false);
          setButtonDisabled(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
  };

  return (
    <>
      <div className=''>
        <Button
          disabled={buttonDisabled}
          type='button'
          className='buttonMain'
          onClick={() => handleTodaysRoute()}
        >
          {!isLoading && <div>View Today's Route</div>}
          {isLoading && (
            <div className='flex justify-center items-center w-[122px]'>
              <MoonLoader size={15} />
            </div>
          )}
        </Button>
      </div>
      <ViewReportModal
        show={show}
        setShow={setshow}
        url={pdfURL}
        fileName={fileName}
        blob={pdfBlob}
      />
    </>
  );
}
